import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { CITIES } from "../lib/cities";

export const CityStrip = ({ exclude }) => (
  <div className="bg-[#f5f3ee] border-b border-[#e3e0d3]" data-testid="city-strip">
    <div className="max-w-7xl mx-auto px-6 py-5 flex flex-wrap items-center gap-x-3 gap-y-2">
      <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.25em] font-heading font-bold text-[#0d2f4d]">
        <MapPin size={13} className="text-[#7C8514]" /> Recruiting in:
      </span>
      {CITIES.filter((c) => c.slug !== exclude).map((c) => (
        <Link key={c.slug} to={`/recruiting/${c.slug}`} data-testid={`city-link-${c.slug}`}
          className="rounded-full border border-[#e3e0d3] bg-white px-4 py-1.5 text-sm font-medium text-[#0d2f4d] hover:bg-[#C1CC24] hover:border-[#C1CC24] transition-colors">
          {c.name}
        </Link>
      ))}
    </div>
  </div>
);
